import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './../store'
import * as $alertme from '@/services/alertme'
// import * as _CONFIG from '@/config'
import goTo from 'vuetify/lib/services/goto'

//importacao das rotas de login
import AuthRoutes from '@/components/auth/route'
//
const Home = () => import('@/components/home/Home.vue')
const MeusDados = () => import('@/components/minha-conta/MinhaConta.vue')
const MeuLocal = () => import('@/components/minha-conta/MeuLocal.vue')
const MeusUsuarios = () => import('@/components/minha-conta/MeusUsuarios.vue')
const Notification = () => import('@/components/minha-conta/Notification.vue')
const AlterarSenha = () => import('@/components/minha-conta/AlterarSenha.vue')
const ListaCams = () => import('@/components/scan/ListaCam.vue')
const PerfilLocal = () => import('@/components/minha-conta/PerfilLocal.vue')
const PlanoScan = () => import("@/components/pagamento/PlanoScan.vue")
// const Scan = () => import('@/components/lista-cam/ListaCam.vue')

Vue.use(VueRouter)
const routes = [
  ...AuthRoutes,
  { path:'/local/:hostId',name:'home',component: Home, meta:{auth:true ,admin:false,mod:50}, },
  {path:'/local/:hostId/list-cam',name:'list-cam',component:ListaCams,meta:{auth:true ,admin:false,mod:50}},
  {path:'/local/:hostId/perfil-local',name:'perfil-local',component:PerfilLocal,meta:{auth:true ,admin:false,mod:50}},
  {path:'/local/:hostId/descricao-local',name:'descricao-local',component: MeuLocal, meta:{auth:true ,admin:false,mod:5} },
  {path:'/local/:hostId/meus-dados',name:'meus-dados',component: MeusDados, meta:{auth:true ,admin:false,mod:10} },
  {path:'/local/:hostId/usuarios',name:'usuarios',component: MeusUsuarios, meta:{auth:true ,admin:false,mod:20}},
  {path:'/local/:hostId/minha-assinatura',name:'minha-assinatura',component: PlanoScan, meta:{auth:true ,admin:false,mod:80} },
  {path:'/local/:hostId/alterar-senha',name:'alterar-senha',component: AlterarSenha, meta:{auth:true ,admin:false,mod:40} },
  {path:'/local/:hostId/configuracao-notificacao',name:'configuracao-notificacao',component: Notification, meta:{auth:true ,admin:false,mod:30} },
  { path: '', redirect: '/login' }
]
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
    scrollBehavior: (to, from, savedPosition) => {
      let scrollTo = 0
  
      if (to.hash) {
        scrollTo = to.hash
      } else if (savedPosition) {
        scrollTo = savedPosition.y
      }
  
      return goTo(scrollTo)
    },
  routes
})

router.beforeEach((to, from, next) => {
  let isAuth = store.getters.isLogin;
  if (to.meta.auth && isAuth) {
      next()
  } else if (isAuth == false && to.path != '/login') {
    if(!isAuth==false) {
      return next({ path: '/login' })
    }
    store.commit('setRedirect',to)
    if(Object.prototype.hasOwnProperty.call(to.params,'hostId')) {
      if(to.params.hostId.length>0 && $alertme.isActiveSession(to.params.hostId)) {
        return next()
      }
    }
  }else{
    next()
  }
})
export default router